<template>
    <div>
        <headerNotice routerName='自定义打印项'></headerNotice>
        
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data () {
        return {
            
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        
    },
    methods: {
        
    }
 }
</script>

<style lang='scss' scoped>
 
</style>